//モデル選択
export const modelChoiceOptions = [
  {
    label: "硬式用(77,000円)",
    value: "硬式用(77,000円)",
    description: "硬式用のグラブです",
    cost: 70000,
  },
  {
    label: "軟式用(66,000円)",
    value: "軟式用(66,000円)",
    description: "軟式用のグラブです",
    cost: 60000,
  },
];

//ポジション
export const positionOptions = [
  { label: "投手", value: "投手", description: "投手用のグラブが表示されます" },
  { label: "内野", value: "内野", description: "内野用のグラブが表示されます" },
  { label: "外野", value: "外野", description: "外野用のグラブが表示されます" },
];

// 型名（ポジションごとに分類）
export const typeNameOptionsByPosition = {
  投手: [
    {
      label: "TSN",
      value: "TSN",
      size: "全長29.5cm",
      description:
        "小型の投手用。操作性にも優れていてポケットは深く作れる縦型モデルです。",
    },
    {
      label: "TLN",
      value: "TLN",
      size: "全長30.5cm",
      description: "大きめの投手用。握り型設計で横型のモデルです。",
    },
  ],
  内野: [
    {
      label: "NMN",
      value: "NMN",
      size: "全長27.4cm",
      description:
        "小型の内野手用。浅めの形状でフィット感があり軽量感にもこだわったモデルです。",
    },
    { label: "NMA", value: "NMA", size: "全長27.4cm", description: "" },
    {
      label: "NWA",
      value: "NWA",
      size: "全長28.0cm",
      description:
        "小ぶりの内野手用ですが、ポケットは深く内野全般対応できる形状です。",
    },
    {
      label: "NLN",
      value: "NLN",
      size: "全長28.3cm",
      description: "",
    },
    { label: "NLA", value: "NLA", size: "全長28.3cm", description: "" },
    {
      label: "KZN",
      value: "KZN",
      size: "全長28.3cm",
      description:
        "ウェブ下での捕球の際、球の収まりがよく特徴的なウェブの形状。大きさはオーソドックスな型で浅め設計です。",
    },
    {
      label: "NQA",
      value: "NQA",
      size: "全長29.0cm",
      description: "大きめの内野手用。ポケットも深く、握り型設計です。",
    },
  ],
  外野: [
    {
      label: "GWA",
      value: "GWA",
      size: "全長31.5cm",
      description:
        "大きさはオーソドックスな型で浅くも深くもできる設計です。軽量感も体感できる操作性がよい型です。",
    },
    {
      label: "GLA",
      value: "GLA",
      size: "全長33.0cm",
      description:
        "大きめな外野手用。縦長でポケットも深く、安心して捕球動作に入りやすい形状です。",
    },
  ],
};

//グラブの左右
export const gloveHandOptions = [
  { label: "右投げ", value: "右投げ", description: "右投げ用" },
  { label: "左投げ", value: "左投げ", vdescription: "左投げ用" },
];

//バックスタイル
export const backStyleOptions = [
  {
    label: "レギュラー",
    value: "レギュラー",
    description: "レギュラーの説明文",
    image: require("@/assets/img/backstyle/backstyle-regular.png"),
    allowedTypeNames: ["NMN", "NMA", "NWA", "NLN", "NLA", "KZN", "NQA", "TSN", "TLN", "GWA", "GLA",],
  },
  {
    label: "王冠",
    value: "王冠",
    description: "王冠の説明文",
    image: require("@/assets/img/backstyle/backstyle-crown.png"),
    allowedTypeNames: ["TSN", "TLN"],
  },
  {
    label: "ライナーバック",
    value: "ライナーバック",
    description: "ライナーバックでは選べない選択肢があります",
    image: require("@/assets/img/backstyle/backstyle-linerback.png"),
    allowedTypeNames: ["NLN", "NLA", "TLN"],
  },
];

// ラベルの左右
export const labelPositionOptions = [
  { label: "親指側", value: "親指側", description: "" },
  { label: "小指側", value: "小指側", description: "" },
];

//ベルト型
export const beltTypeOptions = [
  {
    label: "レギュラー",
    value: "レギュラー",
    displayLabel: "①レギュラー",
    description: "レギュラーの説明文",
  },
  { label: "親指一体", value: "親指一体", displayLabel: "②親指一体", description: "王冠の説明文" },
  {
    label: "セパレート",
    value: "セパレート",
    displayLabel: "③セパレート",
    description: "ライナーバックの説明文",
  },
  { label: "Tベルト", value: "Tベルト", displayLabel: "④Tベルト",  description: "ライナーバックの説明文" },
];
// サイズ調整(指の長さ)
export const fingerSizeOptions = [
  {
    label: "±0",
    value: "±0",
    description:
      "指の長さを、基本型から5mm単位でサイズ変更が可能です。（10mmまで）。",
    cost: 0,
  },
  {
    label: "+5mm（+5,500円）",
    value: "+5mm（+5,500円）",
    description: "",
    cost: 5000,
  },
  {
    label: "+10mm（+5,500円）",
    value: "+10mm（+5,500円）",
    description: "",
    cost: 5000,
  },
  {
    label: "-5mm（+5,500円）",
    value: "-5mm（+5,500円）",
    description: "",
    cost: 5000,
  },
  {
    label: "-10mm（+5,500円）",
    value: "-10mm（+5,500円）",
    description: "",
    cost: 5000,
  },
];

// 背面ひも通し
export const backStrandOptions = [
  {
    label: "なし",
    value: "なし",
    displayLabel: "①なし",
    description: "",
    image: require("@/assets/img/backStrand/backStrand-none.jpg"),
  },
  {
    label: "クロス",
    value: "クロス",
    displayLabel: "②クロス",
    description: "",
    image: require("@/assets/img/backStrand/backStrand-cross.jpg"),
  },
  {
    label: "ストレート",
    value: "ストレート",
    displayLabel: "③ストレート",
    description: "",
    image: require("@/assets/img/backStrand/backStrand-straight.jpg"),
  },
  {
    label: "クロス×ストレート",
    value: "クロス×ストレート",
    displayLabel: "④クロス×ストレート",
    description: "",
    image: require("@/assets/img/backStrand/backStrand-cross-straight.jpg"),
  },
];

// ハミダシ
export const hamidashiChoiceOptions = [
  { label: "切はみ", value: "切はみ", description: "" },
  { label: "玉はみ", value: "玉はみ", description: "" },
];

// トジ部
export const lacePortionOptions = [
  {
    label: "タテトジ",
    value: "タテトジ",
    description: "",
    image: require("@/assets/img/lacePortion/tatetoji.jpg"),
    cost: 0,
  },
  {
    label: "ヨコトジ",
    value: "ヨコトジ",
    description: "",
    image: require("@/assets/img/lacePortion/yokotoji.jpg"),
    cost: 0,
  },
  {
    label: "ヨコトジダブル",
    value: "ヨコトジダブル",
    description: "",
    image: require("@/assets/img/lacePortion/yokotoji-w.jpg"),
    cost: 0,
  },
  {
    label: "ヨコトジダブルひも抜き",
    value: "ヨコトジダブルひも抜き",
    description: "",
    image: require("@/assets/img/lacePortion/yokotoji-w-himonuki.jpg"),
    cost: 0,
  },
  {
    label: "スペースヒンジ（+5,500円）",
    value: "スペースヒンジ（+5,500円）",
    description: "",
    image: require("@/assets/img/lacePortion/space-hinji.jpg"),
    cost: 5000,
  },
  {
    label: "スペースヒンジダブル（+5,500円）",
    value: "スペースヒンジダブル（+5,500円）",
    description: "",
    image: require("@/assets/img/lacePortion/space-hinji-w.jpg"),
    cost: 5000,
  },
  {
    label: "スペースヒンジダブルひも抜き（+5,500円）",
    value: "スペースヒンジダブルひも抜き（+5,500円）",
    description: "",
    image: require("@/assets/img/lacePortion/space-hinji-w-himonuki.jpg"),
    cost: 5000,
  },
];

// トジ部のヒモ通し
export const laceStrandOptions = [
  { label: "レギュラー巻き", value: "レギュラー巻き", description: "" },
  { label: "逆巻き", value: "逆巻き", description: "" },
];

// ウェブ
export const webOptionsByPosition = {
  投手: [
    { label: "W-3", value: "W-3", description: "" },
    { label: "W-5", value: "W-5", description: "" },
    { label: "W-12", value: "W-12", description: "" },
    { label: "W-13", value: "W-13", description: "" },
    { label: "W-T1", value: "W-T1", description: "" },
    { label: "W-T2", value: "W-T2", description: "" },
    { label: "W-T3", value: "W-T3", description: "" },
    { label: "W-T4", value: "W-T4", description: "" },
    { label: "W-T6", value: "W-T6", description: "" },
    { label: "W-T7", value: "W-T7", description: "" },
    { label: "W-T9", value: "W-T9", description: "" },
    // { label: "W-T12", value: "W-T12", description: "" },
  ],
  内野: [
    { label: "W-6", value: "W-6", description: "" },
    { label: "W-8", value: "W-8", description: "" },
    { label: "W-10", value: "W-10", description: "" },
    { label: "W-11", value: "W-11", description: "" },
    { label: "W-12", value: "W-12", description: "" },
    { label: "W-13", value: "W-13", description: "" },
    { label: "W-14", value: "W-14", description: "" },
    { label: "W-15", value: "W-15", description: "" },
    { label: "W-17", value: "W-17", description: "" },
    { label: "W-22", value: "W-22", description: "" },
    { label: "W-23", value: "W-23", description: "" },
    { label: "W-24", value: "W-24", description: "" },
    { label: "W-27", value: "W-27", description: "" },
    { label: "W-28", value: "W-28", description: "" },
    { label: "W-29", value: "W-29", description: "" },
    { label: "W-30", value: "W-30", description: "" },
    { label: "W-T3", value: "W-T3", description: "" },
    { label: "W-T5", value: "W-T5", description: "" },
    { label: "W-T6", value: "W-T6", description: "" },
    { label: "W-T8", value: "W-T8", description: "" },
    // { label: "W-T12", value: "W-T12", description: "" },
  ],
  外野: [
    { label: "W-14", value: "W-14", description: "" },
    { label: "W-15", value: "W-15", description: "" },
    { label: "W-16", value: "W-16", description: "" },
    { label: "W-17", value: "W-17", description: "" },
    { label: "W-19", value: "W-19", description: "" },
    { label: "W-22", value: "W-22", description: "" },
    { label: "W-23", value: "W-23", description: "" },
    { label: "W-T8", value: "W-T8", description: "" },
    { label: "W-T12", value: "W-T12", description: "" },
  ],
}
// export const webOptions = [
//   { label: "W-3", value: "W-3", description: "" },
//   { label: "W-5", value: "W-5", description: "" },
//   { label: "W-6", value: "W-6", description: "" },
//   { label: "W-8", value: "W-8", description: "" },
//   { label: "W-10", value: "W-10", description: "" },
//   { label: "W-11", value: "W-11", description: "" },
//   { label: "W-12", value: "W-12", description: "" },
//   { label: "W-13", value: "W-13", description: "" },
//   { label: "W-14", value: "W-14", description: "" },
//   { label: "W-15", value: "W-15", description: "" },
//   { label: "W-16", value: "W-16", description: "" },
//   { label: "W-17", value: "W-17", description: "" },
//   { label: "W-19", value: "W-19", description: "" },
//   { label: "W-22", value: "W-22", description: "" },
//   { label: "W-23", value: "W-23", description: "" },
//   { label: "W-24", value: "W-24", description: "" },
//   { label: "W-27", value: "W-27", description: "" },
//   { label: "W-28", value: "W-28", description: "" },
//   { label: "W-29", value: "W-29", description: "" },
//   { label: "W-30", value: "W-30", description: "" },
//   { label: "W-T1", value: "W-T1", description: "" },
//   { label: "W-T2", value: "W-T2", description: "" },
//   { label: "W-T3", value: "W-T3", description: "" },
//   { label: "W-T4", value: "W-T4", description: "" },
//   { label: "W-T5", value: "W-T5", description: "" },
//   { label: "W-T6", value: "W-T6", description: "" },
//   { label: "W-T7", value: "W-T7", description: "" },
//   { label: "W-T8", value: "W-T8", description: "" },
//   { label: "W-T9", value: "W-T9", description: "" },
//   { label: "W-T12", value: "W-T12", description: "" },
// ];

// 指カバー・指アテ
export const fingerOptions = [
  {
    label: "なし",
    value: "なし",
    description: "",
    cost: 0,
  },
  {
    label: "指カバー・人差し指",
    value: "指カバー・人差し指",
    description: "",
    cost: 0,
  },
  {
    label: "指カバー・中指（+5,500円）",
    value: "指カバー・中指（+5,500円）",
    description: "",
    cost: 5000,
  },
  {
    label: "指アテ・人差し指",
    value: "指アテ・人差し指",
    description: "",
    cost: 0,
  },
  {
    label: "指アテ・中指（+5,500円）",
    value: "指アテ・中指（+5,500円）",
    description: "",
    cost: 5000,
  },
  {
    label: "ヘリ無し指アテ・人差し指",
    value: "ヘリ無し指アテ・人差し指",
    description: "",
    cost: 0,
  },
  {
    label: "ヘリ無し指アテ・中指（+5,500円）",
    value: "ヘリ無し指アテ・中指（+5,500円）",
    description: "",
    cost: 5000,
  },
];
